import {Controller} from "@mecatran-components/controller";
import {SearchBar} from "SRC/components/searchbar.component.mjs";
/*
import {BackButton} from "../components/backbutton.component.mjs";
import {SearchBox} from "@mecatran-components/searchbox";
*/
import {OriginDestination} from "@mecatran-components/origindestination";
import {InOutbandButton} from "../components/inoutbandbutton.component.mjs";
import {Schedules} from "../components/schedules.component.mjs";
import {ItineraryGroup} from "../services/itineraryprocess/itinerarygroup.service.mjs";
import {ItineraryGroupPreprocessor} from "../services/itineraryprocess/itinerarygrouppreprocessor.service.mjs";


export class ScheduleViewer extends Controller{
    /**
     * 
     * @param view Component [mandatory]
     * @param schoolStation Stop [mandatory]
     * @param scheduleViewerOptions [optional]
     */
    constructor(view,schoolStation,scheduleViewerOptions){
        var scheduleViewerOptions = scheduleViewerOptions || {};
        super(view);
        var _type = (scheduleViewerOptions.homeStation) ? 'home' : 'school';
        console.log('scheduleviewer',schoolStation);

        this.schoolStation = schoolStation;

        /* ======================================= */
        /* PUBLIC                                  */
        /* ======================================= */     
        Object.defineProperty(this,'type',{
            get : function(){ return _type }
        })        
        
        /* ========================================== */
        /* private
        /* ========================================== */




        this.initScheduleViewer(scheduleViewerOptions);
    }
    // ==========
    // private
    // ----------
    getSchoolStation(){ return this.schoolStation; }

    setDirection(d){ this.direction = d }

    getDirection(){ return this.direction }

    swapDirection(){ 
        var direction = this.direction;
        switch(direction){
            case 'inb': 
                this.setDirection('outb');
                break;
            case 'outb':
                this.setDirection('inb');
                break;
        }
    }



    setItineraryGroup(ig){ this.itineraryGroup = ig }

    getItineraryGroup(){ return this.itineraryGroup }


    getNameStr(stop){
        var name = stop.getName();
        var city = stop.getCity(true);
        return `${name} ${city}`
    }



    leaveView(){
        this.removeFromView(this.odName); // replace by closeAll ?
        this.removeFromView(this.searchBoxName);
        this.removeFromView(this.inOutbandButtonName);
        this.removeFromView(this.backButtonName);
        this.removeFromView(this.schedulesName);
        //this.view.clear(this.headerPanelSelector)
    }

    /*
    createLayout(){
        var container = this.createElement('div','schedule-viewer',['schedule-viewer']);
        var inOutbandButton = this.createElement('div','inband-outband-button')
        var backButton = this.createElement('div','back-button')
        var searchBox = this.createElement('div','search-box');
        var od = this.createElement('div','origin-destination')
        var schedules = this.createElement('div','schedules');
        container.appendChild(backButton);
        container.appendChild(searchBox);
        container.appendChild(inOutbandButton);
        container.appendChild(od);
        container.appendChild(schedules);
        return container;
    }
*/

    createElement(type, id,classList= []){
        var el = document.createElement(type);
        el.setAttribute('id',id);
        classList.forEach(klass => el.classList.add(klass));
        return el; 
    }

    createInOutbandButton(){
        return new InOutbandButton();
    }

    createSearchBar(type){
        return new SearchBar(type);
    }

    /*
    createBackButton(){
        return new BackButton();
    }
    */

    createOriginDestinationComponent(homeStation,schoolStation){
        var origin = {}
        var odOptions = { origin }
        var od = new OriginDestination(odOptions);

        od.setOriginValue(this.getNameStr(homeStation));
        od.setDestinationValue(this.getNameStr(schoolStation));
        return od;
    }

/*
    createSearchBoxComponent(schoolStation){
        var inputOptions = { 
            placeholder : 'Choisir un établissement',
            classList : ['search']
        }
        var domOptions = {
            id: 'test1',
            classList : ['search-box']
        }
        var clearButtonUrl = './assets/cross.svg'
        var options = { domOptions , inputOptions, clearButtonUrl }
        var searchBox = new SearchBox(options);
        searchBox.setValue(this.getNameStr(schoolStation));
        return searchBox;
    }
*/

    createSchedulesComponent(itineraryGroup){
        var domOptions = { id : 'schedules', classList : ['schedules']}
        var schedulesOptions = { itineraryGroup, displayAllStops : true, domOptions, direction : this.getDirection() }
        var schedules = new Schedules(schedulesOptions)
        return schedules;
    }

    createItineraryGroup(station){
        var itineraries = station.getItineraries();
        return new ItineraryGroup(itineraries);
    }

    registerInOutbandButton(){
        var name = 'inoutbandbutton';
        this.inOutbandButtonName = name;
        this.register(name, this.createInOutbandButton);
        this.registerEventDefineListener(name,['clickEvent',()=>true,this.onInOutbandClickEvent.bind(this)]);
        this.createComponent(name);
    }

    registerSearchBar(){
        var name = "searchBar";
        this.searchBarName = name;
        this.register(name, this.createSearchBar);
        //this.registerEventDefineListener(name,['inputEvent',()=>true,this.onSearchBoxInputEvent.bind(this)]);
        //this.registerEventDefineListener(name,['click',()=>true,this.onSearchBoxClickEvent.bind(this)]);
        //this.registerEventDefineListener(name,['backEvent',()=>true,this.onBackEvent.bind(this)]);
    }

    /*
    registerBackButton(){
        var name = 'backbutton';
        this.backButtonName = name;
        this.register(name, this.createBackButton);
        this.registerEventDefineListener(name,['backEvent',()=>true,this.onBackEvent.bind(this)]);
        this.createComponent(name);
    }
    */

    registerOriginDestination(){
        var name = 'origindestination';
        //this.setODName(name);
        this.odName = name;
        this.register(name,this.createOriginDestinationComponent)
        this.registerEventDefineListener(name,['reverseEvent',()=>true,this.onReverseClick.bind(this)]);
    }

/*
    registerSearchBox(){
        var name = 'searchbox';
        //this.setSearchBoxName(name);
        this.searchBoxName = name;
        this.register(name, this.createSearchBoxComponent);
    }
*/

    registerSchedules(){
        var name = 'schedules';
        this.schedulesName = name; 
        this.register(name, this.createSchedulesComponent);
    }

    notifyBackEvent(){
        this.leaveView();
        var controllerManager = this.controllerManager;
        var schoolStation = this.schoolStation;
        var type = this.type; 
        if (controllerManager) controllerManager.onBackButton(this, type, schoolStation );// Improve use events or a callback to avoid this dependency
         
    }

    onInOutbandClickEvent(event){
        this.onReverseClick();
    }

    onBackEvent(event){
        this.notifyBackEvent();
    }


    onReverseClick(){
        console.log('reverse was clicked in od', this.getDirection());
        this.swapDirection();
        // 1. update ItineraryGroup 
        var itineraryGroup = this.getItineraryGroup();
        var ItineraryGroup = itineraryGroup.getConstructor(); 
        itineraryGroup = itineraryGroup.getItineraryGroupBy(ItineraryGroup.filterByDirection(this.getDirection()));
        // 2. create a new scheduleComponent
        var sch0 = this.getComponent(this.schedulesName)
        var sch1 = this.createComponent(this.schedulesName, itineraryGroup);
        this.addToView(this.schedulesName, this.schedulesSelector)
    }

    initScheduleViewer(scheduleViewerOptions){

        this.headerPanelSelector = "#header-panel"; 
        this.bodyPanelSelector = "#body-panel"
        this.footerPanelSelector =  "#footer-panel"; 


        // temp 

        this.inOutbandButtonSelector = this.headerPanelSelector;
        this.schedulesSelector = this.bodyPanelSelector;
        this.odSelector = this.headerPanelSelector;


        this.view.hide(this.bodyPanelSelector); // tmp 
        this.view.show(this.footerPanelSelector);

        this.registerInOutbandButton();
        this.registerSearchBar();
        this.registerOriginDestination();
        this.registerSchedules();
        this.setDirection('outb');
        var schoolStation = this.getSchoolStation();
        var homeStation = scheduleViewerOptions.homeStation;
        //this.homeStation = homeStation; 
        var itineraryGroup;

        if (homeStation){

            this.createComponent(this.odName, homeStation, schoolStation);
            this.addToView(this.odName, this.odSelector );
            itineraryGroup = this.createItineraryGroup(homeStation);    
            var itineraryGroupPreprocessor = new ItineraryGroupPreprocessor(itineraryGroup, schoolStation, homeStation);
            itineraryGroup = itineraryGroupPreprocessor.preprocess();
            console.log('================================')
            itineraryGroup.print(homeStation, schoolStation);
            console.log('homeStationId',homeStation.id, 'schoolId',schoolStation.id)
            console.log('--------------------------------')

        } else {  /*only schoolStation is defined */
            /*
            this.createComponent(this.searchBoxName, schoolStation);
            this.addToView(this.searchBoxName, this.searchBoxSelector);
            */

            this.createComponent(this.searchBarName, 'school');
            this.addToView(this.searchBarName, this.headerPanelSelector);
            var searchBar = this.getComponent(this.searchBarName);
            searchBar.setValue(schoolStation.getFullName());

            itineraryGroup = this.createItineraryGroup(schoolStation);
        }
        this.setItineraryGroup(itineraryGroup);
        this.addToView(this.inOutbandButtonName, this.inOutbandButtonSelector);
        this.createComponent(this.schedulesName, itineraryGroup);
        this.addToView(this.schedulesName, this.schedulesSelector)


        this.view.show(this.bodyPanelSelector); // tmp 
        this.view.hide(this.footerPanelSelector);
    }






    // ==========
    // public
    // ----------


    test(name){
        //return this.getComponent(name); 
        var view = this.getView();

        var odName = this.odName;
        var od = this.getComponent(odName);
        view.getStorageManager().addComponent(od,odName);
        view.build();
    }

}


/**
 * ScheduleViewerOptions interface
 * -------------------------------
 * homeStation - type Stop - optional 
 * view - type Component - optional 
 */
